function ok() { return { ok: true }; }
function requireLiteral(config) {
    const c = config;
    if (typeof c.literal !== 'string')
        return { ok: false, errors: [{ field: 'literal', message: 'literal is required' }] };
    return ok();
}
const setLiteral = {
    id: 'set_literal',
    family: 'literal',
    label: 'Replace with literal',
    description: 'Overwrite the value with a fixed string, regardless of input.',
    defaultConfig: { literal: '' },
    evaluate: (_input, config) => config.literal,
    validate: requireLiteral,
    formSchema: [{ key: 'literal', label: 'Literal value', type: 'text', required: true }],
    sampleSeeds: ['anything', '', 'something else'],
};
const prependLiteral = {
    id: 'prepend_literal',
    family: 'literal',
    label: 'Prepend literal',
    description: 'Concatenate a fixed string before the value.',
    defaultConfig: { literal: '' },
    evaluate: (input, config) => {
        const s = input === null || input === undefined ? '' : String(input);
        return config.literal + s;
    },
    validate: requireLiteral,
    formSchema: [{ key: 'literal', label: 'Prefix', type: 'text', required: true }],
    sampleSeeds: ['end', '12345', ''],
};
const appendLiteral = {
    id: 'append_literal',
    family: 'literal',
    label: 'Append literal',
    description: 'Concatenate a fixed string after the value.',
    defaultConfig: { literal: '' },
    evaluate: (input, config) => {
        const s = input === null || input === undefined ? '' : String(input);
        return s + config.literal;
    },
    validate: requireLiteral,
    formSchema: [{ key: 'literal', label: 'Suffix', type: 'text', required: true }],
    sampleSeeds: ['start', '42', ''],
};
export const literalOps = [setLiteral, prependLiteral, appendLiteral];
//# sourceMappingURL=literal-ops.js.map